import { computed, defineComponent, provide } from 'vue';
import { PanelPickerContext, PanelPresetsContext } from './context';
import Divider from '../divider';
import PanelPicker from './components/PanelPicker';
import PanelPresets from './components/PanelPresets';
const ColorPickerPanel = defineComponent({
    name: 'ColorPickerPanel',
    inheritAttrs: false,
    props: ['prefixCls', 'presets', 'onChange', 'onClear', 'color', 'panelRender', 'formatOptions'],
    setup(props, { attrs }) {
        const colorPickerPanelPrefixCls = computed(() => `${props.prefixCls}-inner-content`);
        // ==== Inject props ===
        const panelPickerProps = computed(() => ({
            prefixCls: props.prefixCls,
            value: props.color,
            formatOptions: props.formatOptions,
            onChange: props.onChange,
            onClear: props.onClear,
            ...attrs,
        }));
        const panelPresetsProps = computed(() => ({
            prefixCls: props.prefixCls,
            value: props.color,
            presets: props.presets,
            onChange: props.onChange,
        }));
        // ==== Inject ===
        provide(PanelPickerContext, panelPickerProps);
        provide(PanelPresetsContext, panelPresetsProps);
        // ==== Render ===
        const innerPanel = computed(() => (<>
        <PanelPicker />
        {Array.isArray(props.presets) && (<Divider class={`${colorPickerPanelPrefixCls.value}-divider`}/>)}
        <PanelPresets />
      </>));
        return () => (<div class={colorPickerPanelPrefixCls.value}>
        {typeof props.panelRender === 'function'
                ? props.panelRender(innerPanel.value, {
                    components: { Picker: PanelPicker, Presets: PanelPresets },
                })
                : innerPanel.value}
      </div>);
    },
});
export default ColorPickerPanel;
